import clsx from "clsx";
import { PropsWithChildren } from "react";

enum Size {
  small = "w-6 h-6",
  large = "w-8 h-8",
}
export interface IconButtonProps {
  action?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
  extraClasses?: string;
  rounded?: boolean;
  borderless?: boolean;
  isDisabled?: boolean;
  hoverEffect?: boolean;
  size?: keyof typeof Size;
}

export const IconButton = ({
  children,
  action,
  dataTestId,
  extraClasses = "",
  rounded = false,
  borderless = false,
  isDisabled = false,
  hoverEffect = false,
  size = "small",
}: PropsWithChildren<IconButtonProps>) => {
  return (
    <button
      data-testid={dataTestId ?? "icon-button"}
      disabled={isDisabled}
      onClick={action}
      className={clsx(
        rounded ? "rounded-full" : "rounded-sm",
        {
          "border-0": borderless,
          "cursor-pointer": !isDisabled,
          "hover:bg-neutral-200": hoverEffect,
          "text-neutral-300": isDisabled,
          "text-text-base-primary": !isDisabled,
        },
        ["color-dark", "leading-none", "flex", "items-center", "justify-center"],
        Size[size],
        extraClasses
      )}
    >
      {children}
    </button>
  );
};

const SrOnlyText = ({ children, ...props }: PropsWithChildren<{ className?: string }>) => {
  return <span className={clsx("sr-only", props.className)}>{children}</span>;
};

const Icon = ({ children, ...props }: PropsWithChildren<{ className?: string }>) => {
  return <i {...props} className={clsx(`${children}`, "text-sm", props.className)} />;
};

IconButton.SrOnlyText = SrOnlyText;
IconButton.Icon = Icon;

export default IconButton;
